import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import AHDate from "_shared/dates/date";
import Guid from "_shared/guids/guid";
import OpenEntityMemberInvitationSchema, { OpenEntityMemberInvitationJSON, OpenEntityMemberInvitationParams } from "legal-entities/invitations/member-invitations/open/_schema/open-entity-member-invitation-schema";
import LegalEntity from "legal-entities/legal-entity";
import Entity from "_framework/entities/entity";

export default class OpenEntityMemberInvitation extends Entity<OpenEntityMemberInvitation, OpenEntityMemberInvitationJSON, OpenEntityMemberInvitationParams> {
  public static create(params: OpenEntityMemberInvitationParams): OpenEntityMemberInvitation {
    const parsed = OpenEntityMemberInvitationSchema.validate(params);
    if (isNullOrUndefined(parsed)) {
      throw new Error("Invalid OpenEntityMemberInvitation parameters.");
    }
    return new OpenEntityMemberInvitation(parsed);
  }

  public static fromJSON(json: OpenEntityMemberInvitationJSON): OpenEntityMemberInvitation {
    if (isNullOrUndefined(json)) return json;
    const params = OpenEntityMemberInvitationSchema.deserialize(json);
    return new OpenEntityMemberInvitation(params);
  }

  public static fromJSONArray(
    jsonArray: OpenEntityMemberInvitationJSON[] | null | undefined
  ): OpenEntityMemberInvitation[] | null | undefined {
    if (isNullOrUndefined(jsonArray)) return jsonArray;
    if(jsonArray.length === 0) return [];
    return jsonArray.map(json => OpenEntityMemberInvitation.fromJSON(json));
  }

  public readonly id?: Guid; // TODO: Not undefined-able? in the server-side OpenEntityMemberInvitation class.
  public readonly entity: LegalEntity;
  public readonly expires?: AHDate; // TODO: Not undefined-able? in the server-side OpenEntityMemberInvitation class.

  public constructor(params: OpenEntityMemberInvitationParams) {
    super(params);
    this.id = params.id;
    this.entity = LegalEntity.create(params.entity);
    this.expires = params.expires;
  }

  public toJSON(): OpenEntityMemberInvitationJSON {
    return OpenEntityMemberInvitationSchema.serialize(this);
  }

  public valueOf(): OpenEntityMemberInvitationJSON {
    return this.toJSON();
  }

  public isEqualTo(other: OpenEntityMemberInvitation | null | undefined): boolean {
    return this.id?.isEqualTo(other?.id ?? new Guid("")) ?? false;
  }

  public toString(): string {
    return `OpenEntityMemberInvitation (
      id: ${this.id?.value}
      entity: ${this.entity.toString()}
      expires: ${this.expires?.toString()}
    )`;
  }
}
